{
  "staff-selection-dialog": {
    "buttons": {
      "close": "Zavřít",
      "select": "Vyberte",
      "selected": "Vybrané stránky"
    },
    "text": {
      "title": "Výběr zaměstnanců",
      "first-available": "První volní zaměstnanci"
    }
  }
}
